import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute - Guard route using Entra group membership
 * Redirects unauthenticated users to login
 * Redirects users not in GoaAdmin or GoaMembers to access-denied
 * Redirects non-admin users away from admin routes
 */
export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, isMember, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner" style={{ width: '40px', height: '40px', margin: '0 auto 1rem', borderRadius: '50%', border: '4px solid #f3f3f3', borderTop: '4px solid #667eea', animation: 'spin 1s linear infinite' }}></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (!isAdmin && !isMember) {
    return <Navigate to="/access-denied" />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/briefing/01" />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;

